// extracted by mini-css-extract-plugin
export default {"map_container":"styles_map_map_container__i6LW0","map":"styles_map_map__IlP+8","yearSelector":"styles_map_yearSelector__NBigd","tableOverlay":"styles_map_tableOverlay__2nBP1"};